import { BulletList as BaseBulletList } from "@tiptap/extension-bullet-list";

export const BulletList = BaseBulletList.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      class: {
        default: "rich-text rich-text--bullet",
        renderHTML: () => ({ class: "rich-text rich-text--bullet" }),
      },
    };
  },
});
